import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { MaterialModule } from '../material.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { RouterModule } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SharedModule } from '../shared/shared.module';
import { CaseActivityItemComponent } from './case-activity-item/case-activity-item.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    PerfectScrollbarModule,
    RouterModule,
    NgxChartsModule,
    NgSelectModule,
    SharedModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    DashboardComponent,
    CaseActivityItemComponent,
  ]
})
export class DashboardModule { }
